<script setup>
import { computed } from 'vue';
import GamesOverview from './GamesOverview.vue';
import GameDetails from './GameDetails.vue';

const props = defineProps({
	games: { type: Array, default: () => [] },
	contentFiles: { type: Object, default: () => ({}) },
	user: { type: Object, required: true },
	handleArticleAction: { type: Function, required: true },
	selectedGameId: { type: String, default: 'g0' },
	selectGame: { type: Function, required: true },
	openArticleSummary: { type: Function, required: true },
	isShareSheetOpen: Boolean,
	isSidebarVisible: Boolean,
	windowWidth: { type: Number, default: 0 },
	toggleModals: { type: Function, required: true },
	toggleSidebar: { type: Function, required: true },
	tagEvent: { type: Function, required: true },
});

const games = computed(() => props.games.flatMap(category => (category.articles || []).map(game => ({
	...game,
	category: category.label,
	categoryId: category.id,
}))));
const activeGame = computed(() => games.value.find(game => game.id === props.selectedGameId) || games.value.find(game => game.id === 'g0'));
</script>

<template>
	<main id="games-overview">
		<GamesOverview
			v-if="activeGame?.id === 'g0'"
			:games="games"
			:selectGame="selectGame"
		/>
		<GameDetails
			v-else-if="activeGame"
			:game="activeGame"
			:contentFiles="contentFiles"
			:user="user"
			:handleArticleAction="handleArticleAction"
			:openArticleSummary="openArticleSummary"
			:isShareSheetOpen="isShareSheetOpen"
			:isSidebarVisible="isSidebarVisible"
			:windowWidth="windowWidth"
			:toggleModals="toggleModals"
			:toggleSidebar="toggleSidebar"
			:tagEvent="tagEvent"
		/>
	</main>
</template>

<style lang="scss" scoped>
.games-page { padding-top: 30px !important; overflow-x: hidden; }
#games-overview { position: sticky; inset: 0 calc(-1 * var(--sidebar-width)) 0 var(--sidebar-width); box-sizing: border-box; flex: 1 1 auto; width: var(--main-content-width); max-height: 100dvh; overflow: auto; padding: 30px var(--container-padding) 150px; background: var(--bg2); z-index: 10; }
#app.resizing #games-overview { transition: all .3s ease; }
@media (min-width: 768px) { #games-overview { inset: 0 0 0 360px; max-width: var(--main-content-width); } }
@media (min-width: 1024px) { #games-overview { inset: 0 auto 0 var(--sidebar-width); width: var(--main-content-width); max-width: none; } }
#app:has(#sidebar.collapsed) #games-overview { left: 0; right: 0; width: 100vw; max-width: 100vw; }
</style>
